// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var MessageBoxType;
(function (MessageBoxType) {
    MessageBoxType[MessageBoxType["Error"] = 1] = "Error";
    MessageBoxType[MessageBoxType["Info"] = 2] = "Info";
    MessageBoxType[MessageBoxType["Question"] = 3] = "Question";
    MessageBoxType[MessageBoxType["Warning"] = 4] = "Warning";
    MessageBoxType[MessageBoxType["Approve"] = 5] = "Approve";
    MessageBoxType[MessageBoxType["YellowInfo"] = 6] = "YellowInfo";
})(MessageBoxType || (MessageBoxType = {}));
export var MessageBoxButtonsTextKey;
(function (MessageBoxButtonsTextKey) {
    MessageBoxButtonsTextKey["Ok"] = "general.messageBox.ok";
})(MessageBoxButtonsTextKey || (MessageBoxButtonsTextKey = {}));
export let showMessageBoxAsync;
export function setMessageBoxAsyncHandler(handler) {
    showMessageBoxAsync = handler;
}
export let showCertificateScreenAsync;
export function setCertificateScreenHandler(handler) {
    showCertificateScreenAsync = handler;
}
// #endregion
